/**
 * The detail of a failed request, fit to print after a sentence that says what
 * could not be read (op-g2-1).
 *
 * The shared client unwrap composes `HTTP <status>: <reason phrase>` when an
 * error carries no JSON body. An HTTP/2 response has no reason phrase, so the
 * message ends in a bare colon, and the ATTOM page printed "HTTP 404:" as the
 * whole error detail. This trims the dangling separator (and a closing period,
 * since callers end their own sentence), and an empty detail
 * says so in words instead of printing nothing.
 */

/** What prints when a failed request returned no detail at all. */
export const NO_FAILURE_DETAIL = 'no detail was returned';

export function readFailureDetail(error: unknown): string {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  const trimmed = message.trim().replace(/[\s:;,.]+$/, '');
  return trimmed || NO_FAILURE_DETAIL;
}
